import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {
    CircularProgress,
    Grid,
    TextField,
    useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import emailjs from '@emailjs/browser';
import { SnackbarProvider, useSnackbar } from 'notistack';





const InquireForm = (props) => {


    const { enqueueSnackbar } = useSnackbar();


    const mailhandleClickVariant = (variant) => () => {
        enqueueSnackbar('Thank you for you message. It has been sent', { 
            variant: variant,
            anchorOrigin: {
                horizontal: 'right',
                vertical: 'bottom',
              },
         });
    };
    

    const [formData, setFormData] = useState({
        name: "",
        nameError: "",
        email: "",
        emailError: "",
        phone: "",
        phoneError: "",
        service: "",
        detail: ""
    });

    const [isFormLoading, setIsFormLoading] = useState(false);

    useEffect(()=>{
        console.log("form data - ", isFormLoading)
    }, [isFormLoading])

    const inquireValidation = (e) => {
        e.preventDefault();
        let isInquireValidate = true;

        if (formData.name.length == 0) {
            isInquireValidate = false;
            setFormData((prevState) => ({
                ...prevState,
                nameError: "Name is required",
            }));
        }else {
            setFormData((prevState) => ({ ...prevState, nameError: "" }));
        }

        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        if (formData.email.length == 0) {
            isInquireValidate = false;
            setFormData((prevState) => ({
                ...prevState,
                emailError: "Email is required",
            }));
        } else if (mailformat.test(formData.email) === false) {
            isInquireValidate = false;
            setFormData((prevState) => ({
                ...prevState,
                emailError: "Email wrong format",
            }));
        } else {
            setFormData((prevState) => ({ ...prevState, emailError: "" }));
        }

        if (formData.phone.length == 0) {
            isInquireValidate = false;
            setFormData((prevState) => ({
                ...prevState,
                phoneError: "Phone Number is required",
            }));
        }else {
            setFormData((prevState) => ({ ...prevState, phoneError: "" }));
        }


        if (isInquireValidate) {
            setIsFormLoading(true);
            // alert("Success");
            console.log("form target", e.target);
            emailjs.sendForm('service_a6mgyef', 'template_mff9ell', e.target, 'E8kTI-4_hqFfxmG7f')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            }).finally(()=>{
                console.log("done");
                setIsFormLoading(false);
                // mailhandleClickVariant('success');
                enqueueSnackbar('Thank you for you message. It has been sent', { 
                    variant: 'success',
                    anchorOrigin: {
                        horizontal: 'right',
                        vertical: 'bottom',
                      },
                 });
                setFormData((prevState) => ({ 
                    ...prevState, 
                    name: "",
                    email: "",
                    phone: "",
                    service: "",
                    detail: ""
                }));
                props.func(false);
            });
        }
    };

    

    return (
        <>
        <form onSubmit={inquireValidation}>
        <Grid container spacing={2} justifyContent="center">
            <Grid item md={6} xs={12}>
                <TextField
                    error={formData.nameError.length == 0 ? false : true}
                    label= {formData.nameError.length == 0 ? "Name" : formData.nameError}
                    value={formData.name}
                    id="outlined-basic"
                    variant="filled"
                    fullWidth
                    size="small"
                    name="name"
                    onChange={(event) =>
                        setFormData({ ...formData, name:event.target.value })
                    }
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <TextField
                    error={formData.emailError.length == 0 ? false : true}
                    label= {formData.emailError.length == 0 ? "Email" : formData.emailError}
                    value={formData.email}
                    id="outlined-basic"
                    variant="filled"
                    fullWidth
                    name="email"
                    size="small"
                    onChange={(event) =>
                        setFormData({ ...formData, email:event.target.value })
                    }
                />
            </Grid>

            <Grid item md={6} xs={12}>
                <TextField
                    error={formData.phoneError.length == 0 ? false : true}
                    label= {formData.phoneError.length == 0 ? "Phone Number" : formData.phoneError}
                    value={formData.phone}
                    id="outlined-basic"
                    variant="filled"
                    fullWidth
                    size="small"
                    name="phone"
                    onChange={(event) =>
                        setFormData({ ...formData, phone:event.target.value })
                    }
                />
            </Grid>
            <Grid item md={6} xs={12}>

                <TextField
                    id="filled-select-currency-native"
                    select
                    value={formData.service}
                    label="Service of interest"
                    // defaultValue="mobile-app"
                    variant="filled"
                    size="small"
                    name="service"
                    fullWidth
                    onChange={(event) =>
                        setFormData({ ...formData, service:event.target.value })
                    }
                >
                    <MenuItem key='mobile-app' value='Mobile Application'>Mobile Application</MenuItem >
                    <MenuItem key='web-app' value='Web Application'>Web Application</MenuItem >
                    <MenuItem key='web' value='Website'>Website</MenuItem >
                    <MenuItem key='uiux' value='UI & UX'>UI & UX</MenuItem >
                </TextField>

            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="outlined-multiline-flexible"
                    label="Details of your request"
                    value={formData.detail}
                    multiline
                    minRows={4}
                    style={{ width: "100%" }}
                    variant="filled"
                    name="detail"
                    onChange={(event) =>
                        setFormData({ ...formData, detail:event.target.value })
                    }
                />
            </Grid>
            <Grid item md={12} xs={12}>
                <Button type="submit" variant="contained" size="large" style={{ width: "100%" }} disabled={isFormLoading ? true : false}>
                    {isFormLoading ? (
                        <CircularProgress style={{width:28,height:28}}></CircularProgress>
                    ) : (
                        <>INQUIRE NOW</>
                    )}
                </Button>
            </Grid>
        </Grid>
        </form>
        </>
    )
}

export default InquireForm;
